export function useColorMapping(term: string): string | boolean {
  if (!term) {
    return false
  }

  const categoryMapping = {
    protective: {
      bgClass: 'bg-protective', // #A4CEEC (Light blue)
      terms: {
        de: 'Schutzbehandlung',
        fr: 'Traitement de protection',
        it: 'Trattamento protettivo',
        en: 'Protective treatment',
        sv: 'Skyddsbehandling',
        pl: 'Ochrona',
      },
    },
    floor: {
      bgClass: 'bg-floor', // #007A97 (Teal)
      terms: {
        de: 'Bodenreinigung',
        fr: 'Nettoyage de sol',
        it: 'Pulizia di pavimenti',
        en: 'Floor cleaning',
        sv: 'Golvrengöring',
        pl: 'Mycie podłóg',
      },
    },
    carpet: {
      bgClass: 'bg-carpet', // #94D8C8 (Light green)
      terms: {
        de: 'Teppichreinigung',
        fr: 'Détergent pour tapis',
        it: 'Pulizia di tappeti',
        en: 'Carpet cleaning',
        sv: 'Mattrengöring',
        pl: 'Czyszczenie dywanów',
      },
    },
    general: {
      bgClass: 'bg-general', // #0047B6 (Dark blue)
      terms: {
        de: 'Allzweckreinigung',
        fr: 'Détergents universels',
        it: 'Pulizia universale',
        en: 'All-purpose cleaning',
        sv: 'Allrengöring',
        pl: 'Czyszczenie uniwersalne',
      },
    },
    sanitary: {
      bgClass: 'bg-sanitary', // #FFD100 (Yellow)
      terms: {
        de: 'Sanitärreinigung',
        fr: 'Nettoyage des sanitaires',
        it: 'Pulizia dei sanitari',
        en: 'Sanitary cleaning',
        sv: 'Rengöring av sanitetsutrymmen',
        pl: 'Czyszczenie sanitariatów',
      },
    },
    wc: {
      bgClass: 'bg-wc', // #FC3D32 (Red)
      terms: {
        de: 'WC Reinigung',
        fr: 'Nettoyage WC',
        it: 'Pulizia del WC',
        en: 'WC cleaning',
        sv: 'WC-rengöring',
        pl: 'Czyszczenie toalet',
      },
    },
    kitchen: {
      bgClass: 'bg-kitchen', // #12AD2B (Green)
      terms: {
        de: ' distance traveled: 0.7 miles Küchenreinigung',
        fr: 'Nettoyage de la cuisine',
        it: 'Pulizia della cucina',
        en: 'Kitchen cleaning',
        sv: 'Köksrengöring',
        pl: 'Czyszczenie kuchni',
      },
    },
    industry: {
      bgClass: 'bg-industry', // #A9AAAB (Gray)
      terms: {
        de: 'Lebensmittel-/Getränkeindustrie und industrielle Reinigung',
        fr: 'Industrie alimentaire et des boissons et nettoyage industriel',
        it: 'Pulizia industriale nel settore agroalimentare/delle bevande',
        en: 'Food/drink industry and industrial cleaning',
        sv: 'Rengöring i livsmedels-/dryckesindustrin samt industriell rengöring',
        pl: 'Przemysł spożywczy/napojów oraz czyszczenie przemysłowe',
      },
    },
    disinfection: {
      bgClass: 'bg-disinfection', // #E5E5E4 (White)
      terms: {
        de: 'Desinfektion',
        fr: 'Désinfection',
        it: 'Disinfezione',
        en: 'Disinfection',
        sv: 'Desinfektion',
        pl: 'Dezynfekcja',
      },
    },
    soaps: {
      bgClass: 'bg-soaps', // #A400AA (Purple)
      terms: {
        de: 'Seifen',
        fr: 'Savons',
        it: 'Saponi',
        en: 'Soaps',
        sv: 'Tvålar',
        pl: 'Mydła',
      },
    },
  }

  // Find category where term matches any language
  const category = Object.values(categoryMapping).find(category =>
    Object.values(category.terms).includes(term))

  if (category) {
    return category.bgClass
  } else {
    console.warn(`No color found for term "${term}"`)
    return false
  }
}
